/**
 * Generate a small random trace ID.
 * Designed to be unique enough to be used in logs and traces.
 */
export function generateTraceId(): string {
    return crypto.randomUUID().replace(/-/g, '').slice(0, 32);
}

export function generateSpanId(): string {
    return crypto.randomUUID().replace(/-/g, '').slice(0, 16);
}
